import { DrainsAndTubesConstants } from './drainsAndTubes.constants'
import { IDrainsAndTubesAction, IDrainsAndTubesState } from './drainsAndTubes.types'

export const initialDrainsAndTubesState: IDrainsAndTubesState = {
  ngTube: '',
  ngTubeSuction: null,
  ogTube: '',
  ogTubeSuction: null,
  chestTubeL: '',
  chestTubeLSuction: null,
  chestTubeR: '',
  chestTubeRSuction: null,
  foley: '',
  foleyColor: null,
  pegTube: '',
  pegTubeCapped: null,
  ileostomy: null,
  colostomy: null,
  ventriculostomy: '',
  csfColor: null,
  comments: '',
}

export function drainsAndTubesReducer(
  state: IDrainsAndTubesState = initialDrainsAndTubesState,
  action: IDrainsAndTubesAction
): IDrainsAndTubesState {
  switch (action.type) {
    case DrainsAndTubesConstants.SET_NG_TUBE:
      return { ...state, ngTube: action.ngTube }
    case DrainsAndTubesConstants.SET_NG_TUBE_SUCTION:
      return { ...state, ngTubeSuction: action.ngTubeSuction }
    case DrainsAndTubesConstants.SET_OG_TUBE:
      return { ...state, ogTube: action.ogTube }
    case DrainsAndTubesConstants.SET_OG_TUBE_SUCTION:
      return { ...state, ogTubeSuction: action.ogTubeSuction }
    case DrainsAndTubesConstants.SET_CHEST_TUBE_L:
      return { ...state, chestTubeL: action.chestTubeL }
    case DrainsAndTubesConstants.SET_CHEST_TUBE_L_SUCTION:
      return { ...state, chestTubeLSuction: action.chestTubeLSuction }
    case DrainsAndTubesConstants.SET_CHEST_TUBE_R:
      return { ...state, chestTubeR: action.chestTubeR }
    case DrainsAndTubesConstants.SET_CHEST_TUBE_R_SUCTION:
      return { ...state, chestTubeRSuction: action.chestTubeRSuction }
    case DrainsAndTubesConstants.SET_FOLEY:
      return { ...state, foley: action.foley }
    case DrainsAndTubesConstants.SET_FOLEY_COLOR:
      return { ...state, foleyColor: action.foleyColor }
    case DrainsAndTubesConstants.SET_PEG_TUBE:
      return { ...state, pegTube: action.pegTube }
    case DrainsAndTubesConstants.SET_PEG_TUBE_CAPPED:
      return { ...state, pegTubeCapped: Number(action.pegTubeCapped) }
    case DrainsAndTubesConstants.SET_ILEOSTOMY:
      return { ...state, ileostomy: action.ileostomy }
    case DrainsAndTubesConstants.SET_COLOSTOMY:
      return { ...state, colostomy: action.colostomy }
    case DrainsAndTubesConstants.SET_VENTRICULOSTOMY:
      return { ...state, ventriculostomy: action.ventriculostomy }
    case DrainsAndTubesConstants.SET_CSF_COLOR:
      return { ...state, csfColor: action.csfColor }
    case DrainsAndTubesConstants.SET_COMMENTS_OTHER:
      return { ...state, comments: action.comments }
    case DrainsAndTubesConstants.SET_DRAINS_AND_TUBES:
      return { ...action.drainsAndTubes }
    case DrainsAndTubesConstants.RESET_DRAINS_AND_TUBES:
      return {
        ngTube: '',
        ngTubeSuction: null,
        ogTube: '',
        ogTubeSuction: null,
        chestTubeL: '',
        chestTubeLSuction: null,
        chestTubeR: '',
        chestTubeRSuction: null,
        foley: '',
        foleyColor: null,
        pegTube: '',
        pegTubeCapped: null,
        ileostomy: null,
        colostomy: null,
        ventriculostomy: '',
        csfColor: null,
        comments: '',
      }
    default:
      return state
  }
}
